import { motion } from "framer-motion";
import React, { useCallback, useEffect, useState } from "react";
import CheckMarker from "../../../../../../../../assets/images/checkMarker.svg";
import Loading from "../../../../../../../../core/common/Loading";
import api from "../../../../../../../../services/api";
import Ticket from "../Payment/Ticket";
import { IPaymentTicket } from "../Payment/types/types";
// import { Container } from './styles';

interface Props {
  onClose: () => void;
}

const Invoiced: React.FC<Props> = (props: Props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [dataTicket, setDataTicket] = useState<IPaymentTicket>();
  const [showTicket, setShowTicket] = useState<boolean>(false);

  const pageVariants = {
    initial: { opacity: 0, x: 100 },
    animate: { opacity: 1, x: 0, transition: { duration: 0.8 } },
    exit: { opacity: 0, x: 100, transition: { duration: 0.5 } },
  };

  const isFaturada = React.useMemo(() => {
    const pagamentos: any[] | undefined =
      (dataTicket as any)?.operacaoPatio?.pagamento;
    if (!pagamentos || pagamentos.length === 0) {
      return (dataTicket as any)?.operacaoPatio?.operacao_porto_carrossel != null;
    }
    const activePayments = pagamentos.filter((p: any) => Number(p.status) === 0 || p.status === undefined);
    if (activePayments.length === 0) {
      return (dataTicket as any)?.operacaoPatio?.operacao_porto_carrossel != null;
    }
    const ultimoPagamento = activePayments[activePayments.length - 1];
    return Number(ultimoPagamento?.tipo_pagamento) === 3;
  }, [dataTicket]);

  const getPaymentTicket = useCallback(async () => {
    try {
      setLoading(true);

      let getDataTriagem: any = localStorage.getItem("@triagem");
      if (getDataTriagem) {
        getDataTriagem = JSON.parse(getDataTriagem);
      }
      const idOperacaoPatio = localStorage.getItem("id_operacao_patio");

      const id =
        idOperacaoPatio && idOperacaoPatio.length > 0
          ? idOperacaoPatio
          : getDataTriagem?.id_operacao_patio;

      const body = {
        id_operacao_patio: id,
      };

      const response = await api.post("/operacaopatio/custoOperacao", body);

      if (response.status === 200) {
        setDataTicket(response.data);

        setShowTicket(true);
      }

      setLoading(false);
    } catch {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getPaymentTicket();
  }, [getPaymentTicket]);
  
  return (
    <>
    <Loading loading={loading} skeletonVariant="card" skeletonFields={4} />
      {showTicket && (
        <div className="hidden">
          <Ticket
            numPages={1}
            data={dataTicket}
            onClose={() => {
              /* Mantido vazio: o Ticket permanece montado até o usuário clicar em Finalizar,
                 evitando o erro "removeChild" causado pelo desmonte concorrente com a
                 limpeza do iframe do react-to-print. */
            }}
          />
        </div>
      )}
      <motion.div
        initial="initial"
        animate="animate"
        exit="exit"
        variants={pageVariants}
        className="page"
      >
        <div className="overflow-y-scroll max-h-[650px] p-10">
          <div className="w-full h-full flex items-center justify-center">
            <div className="flex items-center h-full">
              <div
                className={`w-10 h-10 flex items-center justify-center rounded-full ${"bg-[#006400]"}`}
              >
                <img src={CheckMarker} />
              </div>
              <span className="ml-4 text-base text-[#000] font-bold">
                {isFaturada
                  ? "Triagem faturada com sucesso!"
                  : "Triagem concluída com sucesso!"}
              </span>
            </div>
          </div>
        </div>
      </motion.div>
      <div className="w-full h-14 flex items-center justify-end bg-[#FFFFFF] shadow-xl">
        <button
          type="button"
          className="w-24 h-9 pl-3 pr-3 flex items-center justify-center bg-[#0A4984] text-sm text-[#fff] font-bold rounded-full mr-2"
          onClick={() => props.onClose()}
          id="btnFinish"
        >
          Finalizar
        </button>
      </div>
    </>
  );
};

export default Invoiced;
